var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("\n    "+_vm._s(_vm._f("short_date_format")(_vm.file.createdAt))+"\n  ")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.file.OldFile.type)+"\n  ")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":'https://techcar-dev.s3.amazonaws.com/' + _vm.file.objectKey,"target":"_blank"}},[_c('span',{staticClass:"fa fa-download fa-fw"}),_vm._v(" Download\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715872fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rows/AccountFile.vue
// module id = 1167
// module chunks = 1